/**
 * ScanPayPromo.jsx
 * Created by Destin Frasier on 10/30/20.
 */

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useOffsetSize} from '../../../hooks';
import * as Icons from '../icons/Icons';
import ImageWithFallback from '../ImageWithFallback';

export default function ScanPayPromo({
    ariaLabel,
    inventoryType,
    buttonCopy,
    href,
    showArrow,
    className,
}) {

    const targetRef = useRef();
    const { width } = useOffsetSize(targetRef);

    const arrow  = (
        <span className="rec-scan-pay-promo-icon-wrap">
            <Icons.IconArrowForward />
        </span>
    );

    const promoButtonCopy = () => {
        return (
            buttonCopy.length >= 1 ? (
                <span className="rec-scan-pay-promo-button-text">
                    &nbsp;{buttonCopy}
                    {arrow}
                </span>
            ) : (
                <span className="rec-scan-pay-promo-button-text">
                    {showArrow && (
                        arrow
                    )}
                </span>
            )
        );
    }

    const scanPayBody = () => {
        return (
            <div className={cx('rec-scan-pay-promo-inner-wrap')}>
                <div className="rec-scan-pay-promo-text-block">
                    <ImageWithFallback
                        imagePath={`${process.env.CDN}/img/global/scan-pay/scan-pay-icon`}
                        alt="Scan & Pay"
                        imgHeight="55px"
                        imgWidth="31px" />
                    <p>
                        This {inventoryType} uses <i>Scan & Pay</i> to accept on-site payment through the Recreation.gov mobile app.
                        {href && (
                            promoButtonCopy()
                        )}
                    </p>
                </div>
                {width > 500 && (
                <div className="rec-scan-pay-promo-phone-block">
                    <ImageWithFallback
                        imagePath={`${process.env.CDN}/img/global/scan-pay/iphone_mobile-app`}
                        alt="Scan & Pay on Recreation.gov app"
                        imgHeight="92px"
                        imgWidth="91px" />
                </div>
                )}
            </div>
        );
    }

    return (
        <div ref={targetRef} className={cx(className, 'rec-scan-pay-promo-wrap')}>
            {href ? (
                <a
                    href={href}
                    aria-label={ariaLabel}
                    target="_blank"
                    rel="noopener noreferrer" >
                        {scanPayBody()}
                </a>
                ) : (
                <React.Fragment>
                    {scanPayBody()}
                </React.Fragment>
            )}
        </div>
    );
}

ScanPayPromo.propTypes = {
    /** Aria-Label for the promo */
    ariaLabel: PropTypes.string,

    /** Bold copy displayed directly before the arrow */
    buttonCopy: PropTypes.string,

    /** Added to existing classes */
    className: PropTypes.string,

    /** Copy for the promo */
    inventoryType: PropTypes.string,

    /** Url for the promo */
    href: PropTypes.string,

    // Show or hide the arrow directly after the promo copy */
    showArrow: PropTypes.bool,
};

ScanPayPromo.defaultProps = {
    ariaLabel: 'Scan & Pay is available at this location',
    buttonCopy: 'Learn More',
    className: undefined,
    inventoryType: 'campground',
    href: undefined,
    showArrow: true,
};
